import { useEffect, useRef, useState } from 'react';
import { send } from './api.js';
import { Notice } from './components.js';
import { t } from './i18n.js';

export function ReplyPresence({ messageId, mailboxId }: { messageId: string; mailboxId: string }) {
  const clientId = useRef(crypto.randomUUID());
  const [peers, setPeers] = useState<{ userId: string; name: string }[]>([]);
  const [unavailable, setUnavailable] = useState(false);
  useEffect(() => {
    let alive = true,
      running = false;
    const headers = { 'X-Mailbox-Id': mailboxId };
    const beat = async () => {
      if (running || document.visibilityState === 'hidden') return;
      running = true;
      try {
        const r = await send(
          `/messages/${messageId}/reply-presence`,
          { clientId: clientId.current, active: true },
          'PUT',
          headers,
        );
        if (alive) {
          setPeers(r.peers);
          setUnavailable(false);
        }
      } catch (e: any) {
        if (alive) {
          setPeers([]);
          setUnavailable(![403, 404].includes(e.status));
        }
      } finally {
        running = false;
      }
    };
    void beat();
    const timer = setInterval(() => void beat(), 20000);
    document.addEventListener('visibilitychange', beat);
    return () => {
      alive = false;
      clearInterval(timer);
      document.removeEventListener('visibilitychange', beat);
      void send(
        `/messages/${messageId}/reply-presence`,
        { clientId: clientId.current, active: false },
        'PUT',
        headers,
      ).catch(() => {});
    };
  }, [messageId, mailboxId]);
  return (
    <>
      {peers.length > 0 && (
        <Notice type="info">
          {t('Une réponse est déjà en préparation par')} {peers.map((p) => p.name).join(', ')}.{' '}
          {t('Coordonnez-vous avant l’envoi pour éviter une double réponse.')}
        </Notice>
      )}
      {unavailable && (
        <Notice type="info">
          {t('La présence des autres rédacteurs est momentanément indisponible.')}
        </Notice>
      )}
    </>
  );
}
